import { render, staticRenderFns } from "./GStepCard.vue?vue&type=template&id=8bfba202&scoped=true&"
import script from "./GStepCard.vue?vue&type=script&lang=ts&"
export * from "./GStepCard.vue?vue&type=script&lang=ts&"
import style0 from "./GStepCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfba202",
  null
  
)

export default component.exports